import { transientStorageManager } from 'businesslayer/minutesSessionStore'
import { ALLOWED_WRITING_STYLE_VIEWERS, PLATFORM_OPTION } from 'common/constants/constants'

const containsHTML = (input) => {
    const htmlLikeRegex = /[<>]/
    return htmlLikeRegex.test(input)
}

export default containsHTML

export const removeHTML = (input) => {
    const htmlLikeRegex = /<[^>]*>|[<>]/g
    let previous
    do {
        previous = input
        input = input?.replace(htmlLikeRegex, '')
    } while (input !== previous)
    return input?.trim()
}

export enum GRID_UTILS {
    PAGE = 'page',
    SIZE = 'per_page',
    PAGE_SIZE = '20'
}

export const platformSupportsAI = () => {
    const platforms = ['boards', 'boardswebadmin', 'boardsios']

    return platforms.includes(transientStorageManager?.platform ?? '')
}

/**
 * Platforms that can access Writing Style Library routes.
 * Mirrors the Boards/Boards iOS checks, extended for BoardEffect.
 */
export const isWritingStylePlatformSupported = (): boolean => {
    const currentUserPlatform = transientStorageManager?.currentUser?.platform
    const platform = transientStorageManager?.platform

    return (
        currentUserPlatform === PLATFORM_OPTION.BOARDS ||
        currentUserPlatform === PLATFORM_OPTION.BOARD_EFFECT ||
        platform === PLATFORM_OPTION.BOARDIOS ||
        platform === PLATFORM_OPTION.BOARD_EFFECT
    )
}

/**
 * Platforms that show the Writing Style banner on the Minutes Manager home page.
 * Preserves the Boards-only banner rule and extends it to BoardEffect users.
 */
export const isWritingStyleBannerPlatformSupported = (): boolean => {
    const currentUserPlatform = transientStorageManager?.currentUser?.platform

    return (
        currentUserPlatform === PLATFORM_OPTION.BOARDS ||
        currentUserPlatform === PLATFORM_OPTION.BOARD_EFFECT
    )
}

export const isWritingStyleLibraryRouteEnabled = (): boolean => {
    return (
        isWritingStylePlatformSupported() && Boolean(transientStorageManager.writing_style_enabled)
    )
}

export const shouldShowWritingStyleNavigation = (): boolean => {
    return (
        isWritingStylePlatformSupported() &&
        transientStorageManager.writing_style_enabled &&
        transientStorageManager.book_summarization_enabled
    )
}

export const shouldShowWritingStyleBanner = (canAddMinutes: boolean): boolean => {
    return (
        transientStorageManager.book_summarization_enabled &&
        transientStorageManager.writing_style_enabled &&
        isWritingStyleBannerPlatformSupported() &&
        canAddMinutes
    )
}

/**
 * Check if a user is allowed to view generatedAI writing styles
 * @param {string|null|undefined} userEmail - The email of the current user
 * @returns {boolean} - True if user is allowed, false otherwise
 */
export const isUserAllowedToViewStyle = (userEmail) => {
    if (!userEmail) return false
    const normalizedEmail = userEmail.toLowerCase().trim()
    return ALLOWED_WRITING_STYLE_VIEWERS.some(
        (allowedEmail) => allowedEmail.toLowerCase() === normalizedEmail
    )
}
